// extracted by mini-css-extract-plugin
export default {"container":"CustomerDeliveries_container__bPdgs"};